export const sectionData = [
    {
        id: 1,
        label: 'Популярное',
        trackData: [
            {
                id: 1,
                href: 'piraty_karibskogo_mora_mertvecy_ne_rasskazyvaut_skazki-803614',
                src: '/static/images/domru-tv/look/carousel/pirates22.jpg',
                alt: 'Пираты Карибского Моря: Мертвецы не рассказывают сказки',
            },
            {
                id: 2,
                href: 'mir_dikogo_zapada-327047',
                src: '/static/images/domru-tv/look/carousel/westworld.jpg',
                alt: 'Мир Дикого Запада',
            },
            {
                id: 3,
                href: 'gadkij_a_3-2017-811628',
                src: '/static/images/domru-tv/look/carousel/despicableme.jpg',
                alt: 'Гадкий Я 3',
            },
            {
                id: 4,
                href: 'krovavaa_baryna-1122527',
                src: '/static/images/domru-tv/look/carousel/blood.jpg',
                alt: 'Кровавая Барыня',
            },
        ],
        slidesData: [
            { href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/olga.jpg', alt: 'Ольга', cost: '299 ₽' },
            { href: 'https://movix.ru/movies/matilda-875592?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/matilda.jpg', alt: 'Матильда', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/snegovik-1125199?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/snowman.jpg', alt: 'Снеговик', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/dzungli-879409?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/jungle.jpg', alt: 'Джунгли', cost: '149 ₽' },
            { href: 'https://movix.ru/movies/transformery_poslednij_rycar-785181?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/transformers.jpg', alt: 'Трансформеры: Последний рыцарь', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/mumia-800405?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/mummy.jpg', alt: 'Мумия', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/gogol_nacalo-800100?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/gogol.jpg', alt: 'Гоголь. Начало', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/moana-330374?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/moana.jpg', alt: 'Моана', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/tor_ragnarek-1122317?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/thorragnarock.jpg', alt: 'Тор: Рагнарёк', cost: '299 ₽' },
            { href: 'https://movix.ru/movies/pritazenie-578230?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/attraction.jpg', alt: 'Притяжение', cost: '199 ₽' },
            { href: 'https://movix.ru/series/besstydniki-1000277?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/shameless.jpg', alt: 'Бесстыдники', cost: '199 ₽' },
            { href: 'https://movix.ru/videoteka?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/policeman.jpg', alt: 'Полицейский с Рублевки', cost: '299 ₽' },
            { href: 'https://movix.ru/movies/temnaa_basna-811712?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/darktower.jpg', alt: 'Тёмная башня', cost: '199 ₽' },
            { href: 'https://movix.ru/movies/telohranitel_killera-816232?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/hitmansbodyguard.jpg', alt: 'Телохранитель киллера', cost: '199 ₽' },
            { href: 'https://movix.ru/series/seks_v_bolsom_gorode-259017?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/sexinthecity.jpg', alt: 'Секс в Большом Городе', cost: '349 ₽' },
            { href: 'https://movix.ru/movies/zvezdnye_vojny_probuzdenie_sily-330129?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/starwarstheforceawakens.jpg', alt: 'Звездные войны: Пробуждение силы', cost: '199 ₽' },
        ],
    },
    {
        id: 2,
        label: 'Новинки',
        trackData: [
            {
                id: 1,
                href: 'https://movix.ru/movies/tor_ragnarek-1122317?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look%D0%A2%D1%80%D0%B8%20%D0%B1%D0%BE%D0%B3%D0%B0%D1%82%D1%8B%D1%80%D1%8F%20%D0%A5%D0%BE%D0%B4%20%D0%9A%D0%BE%D0%BD%D1%91%D0%BC',
                src: '/static/images/domru-tv/look/carousel/thor.jpg',
                alt: 'Тор Рагнарёк',
            },
            {
                id: 2,
                href: 'https://movix.ru/movies/tajna_koko-1119600?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/coco_slider.jpg',
                alt: 'Тайна КОКО',
            },
            {
                id: 3,
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/americancrimestory.jpg',
                alt: 'Американская История Преступлений',
            },
            {
                id: 4,
                href: 'https://movix.ru/movies?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/counterpart.jpg',
                alt: 'Двойник',
            },
        ],
        slidesData: [
            {
                href: 'https://movix.ru/series/lapsi-1115169?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/lapsy.jpg', alt: 'Лапси',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/begusij_po_lezviu_2049-2017-1092335?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/bladerunner2049.jpg', alt: 'Бегущий по Лезвию 2049',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/skajlajn_2-2017-1053855?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/skyline2.jpg', alt: 'Скайлайн 2',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/celovek_pauk_vozvrasenie_domoj-803801?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/spiderman.jpg', alt: 'Человек-паук: Возвращение домой',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/movies/strazi_galaktiki_cast_2-2017-781854?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/guardiansofgalaxy2.jpg', alt: 'Стражи Галактики. Часть 2',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/movies/spasateli_malibu_rassirennaa_versia-768651?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/baywatch.jpg', alt: 'Спасатели Малибу (расширенная версия)',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/songs.jpg', alt: 'Песни',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/zdravstvuj_papa_novyj_god_2-1095041?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/daddyshome2.jpg', alt: 'Здравствуй, папа, Новый год 2',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/mify-1079308?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/myphes.jpg', alt: 'Мифы',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/homeland.jpg', alt: 'Родина',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/movies/skif-1122516?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/skif.jpg', alt: 'Скиф',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/fastfurious8.jpg', alt: 'Форсаж 8',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/movies/komatozniki-1092328?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/flatliners.jpg', alt: 'Коматозники',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/temnaa_basna-811712?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/darktower.jpg', alt: 'Тёмная башня',
                title: '',
                cost: '199 ₽',
            },
            {
                href: 'https://movix.ru/series/britania-1123613?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/britania.jpg', alt: 'Британия',
                title: '',
                cost: '299 ₽',
            },
            {
                href: 'https://movix.ru/movies/malys_na_drajve-811858?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/drivebaby.jpg', alt: 'Малыш на драйве',
                title: '',
                cost: '199 ₽',
            },
        ],
    },
    {
        id: 3,
        label: 'Фильмы',
        trackData: [
            {
                id: 1,
                href: 'https://movix.ru/movies?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/americanmade.jpg',
                alt: 'Сделано в Америке',
            },
            {
                id: 2,
                href: 'https://movix.ru/movies/zdravstvuj_papa_novyj_god_2-1095041?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/daddyshome2_slider.jpg',
                alt: 'Здравствуй, папа, Новый год! 2',
            },
            {
                id: 3,
                href: 'https://movix.ru/movies/patdesat_ottenkov_serogo-327448?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/fiftyshadesofgray.jpg',
                alt: 'Пятьдесят оттенков серого',
            },
            {
                id: 4,
                href: 'https://movix.ru/movies?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/venice.jpg',
                alt: 'Его собачье дело',
            },
        ],
        slidesData: [
            {
                href: 'https://movix.ru/movies/kniga_dzunglej-330143?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/junglebook.jpg', alt: 'Книга джунглей',
                title: 'Книга джунглей',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/na_patdesat_ottenkov_temnee-557364?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/50shadesdarker.jpg', alt: 'На пятьдесят оттенков темнее',
                title: 'На пятьдесят оттенков темнее',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/passaziry-2016-571185?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/passengers.jpg', alt: 'Пассажиры',
                title: 'Пассажиры',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/krasavica_i_cudovise_2017-576580?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/beautyandthebeast.jpg', alt: 'Красавица и Чудовище (2017)',
                title: 'Красавица и Чудовище (2017)',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/pohisenie-813250?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/kidnap.jpg', alt: 'Похищение',
                title: 'Похищение',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/izgoj_odin_zvezdnye_vojny_istorii-2016-330381?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/rogueone.jpg', alt: 'Изгой-Один. Звёздные Войны: Истории',
                title: 'Изгой-Один. Звёздные Войны: Истории',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/zdravstvuj_papa_novyj_god-299660?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/daddyshome.jpg', alt: 'Здравствуй, папа, Новый год',
                title: 'Здравствуй, папа, Новый год',
                cost: '149 ₽'
            },
            {
                href: 'https://movix.ru/movies/terminator_genezis-283123?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/terminatorgenesis.jpg', alt: 'Терминатор Генезис',
                title: 'Терминатор Генезис',
                cost: '149 ₽'
            },
            {
                href: 'https://movix.ru/movies/tajna_semi_sester-1046659?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/sevensisters.jpg', alt: 'Тайна семи сестер',
                title: 'Тайна семи сестер',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/dzumandzi-571598?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/jumanji.jpg', alt: 'Джуманджи',
                title: 'Джуманджи',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/kak_vitka_cesnok_vez_lehu_styra_v_dom_invalidov-885182?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/garlic.jpg', alt: 'Как Витька Чеснок вез Леху Штыря в дом инвалидов',
                title: 'Как Витька Чеснок вез Леху Штыря в дом инвалидов',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/missia_nevypolnima_plema_izgoev-284521?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/missionimposible.jpg', alt: 'Миссия невыполнима племя изгоев',
                title: 'Миссия невыполнима племя изгоев',
                cost: '200 ₽'
            },
            {
                href: 'https://movix.ru/movies/poltora_spiona-326410?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/centralintelligence.jpg', alt: 'Полтора шпиона',
                title: 'Полтора шпиона',
                cost: '149 ₽'
            },
            {
                href: 'https://movix.ru/movies/krasotka-330507?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/prettywoman.jpg', alt: 'Красотка',
                title: 'Красотка',
                cost: '150 ₽'
            },
            {
                href: 'https://movix.ru/movies/scastlivogo_dna_smerti-1237986?_ga=2.64526191.1371441707.1527488452-2075825831.1495713864&utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/happy-death-day.jpg', alt: 'Счастливого дня смерти',
                title: 'Счастливого дня смерти',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/strazi_galaktiki-2014-330171', src: '/static/images/domru-tv/look/carousel/guardiansofgalaxy.jpg', alt: 'Стражи Галактики',
                title: 'Стражи Галактики',
                cost: '150 ₽'
            },

        ],
    },
    {
        id: 4,
        label: 'Мультфильмы',
        trackData: [
            {
                id: 1,
                href: 'https://movix.ru/movies/fiksiki_bolsoj_sekret-2017-1053861?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/fiksiki_banner_big.png',
                alt: 'Фиксики: Большой секрет',
            },
            {
                id: 2,
                href: 'https://movix.ru/movies/emodzi_film-2017-816801?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/emoji.jpg',
                alt: 'Эмоджи фильм',
            },
            {
                id: 3,
                href: 'https://movix.ru/movies/holodnoe_serdce-330276?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/frozen.jpg',
                alt: 'Холодное сердце',
            },
            {
                id: 4,
                href: 'https://movix.ru/movies/tacki_3-811787?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/cars3.jpg',
                alt: 'Тачки 3',
            },
        ],
        slidesData: [
            {
                href: 'https://movix.ru/movies/tajna_koko-1119600?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/COCO_min.jpg', alt: 'Тайна Коко',
                title: 'Тайна Коко',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/olaf_i_holodnoe_priklucenie_i_6_zimnih_istorij-1050018?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/olaf.jpg', alt: '«Олаф и холодное приключение» и 6 зимних историй',
                title: '«Олаф и холодное приключение» и 6 зимних историй',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/leotig.jpg', alt: 'Лео и Тиг',
                title: 'Лео и Тиг',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/boss_molokosos-1108399?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/babyboss.jpg', alt: 'Босс-молокосос',
                title: 'Босс-молокосос',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/balerina-1314497?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/ballerina.jpg', alt: 'Балерина',
                title: 'Балерина',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/tajnaa_zizn_domasnih_zivotnyh-333166?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/pets.jpg', alt: 'Тайная жизнь домашних животных',
                title: 'Тайная жизнь домашних животных',
                cost: '149 ₽'
            },
            {
                href: 'https://movix.ru/movies/zveropoj-557371?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/mashabear.jpg', alt: 'Зверопой',
                title: 'Зверопой',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/korol_lev-330283?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/lionking.jpg', alt: 'Король Лев',
                title: 'Король Лев',
                cost: '150 ₽'
            },
            {
                href: 'https://movix.ru/movies/tacki-330234?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/cars.jpeg',
                alt: 'Тачки',
                title: 'Тачки',
                cost: '150 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/booba.jpg', alt: 'Буба',
                title: 'Буба',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/series/masa_i_medved-1356441?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/mashabear.jpg', alt: 'Маша и Медведь',
                title: 'Маша и Медведь',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/smurfiki_zaterannaa_derevna-580339?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/smurfs.jpg', alt: 'Смурфики: Затерянная деревня',
                title: 'Смурфики: Затерянная деревня',
                cost: '199 ₽'
            },
            {
                href: 'https://movix.ru/movies/minony-300575?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/minions.jpg', alt: 'Миньоны',
                title: 'Миньоны',
                cost: '149 ₽'
            },
            {
                href: 'https://movix.ru/movies/ralf-330311?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/ralph.jpg', alt: 'Ральф',
                title: 'Ральф',
                cost: '150 ₽'
            },
            {
                href: 'https://movix.ru/movies/zveropolis-330122?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/zootopia.jpg', alt: 'Зверополис',
                title: 'Зверополис',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies/tri_bogatyra_hod_konem-1122486?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/threebogatirya.jpg', alt: 'Три богатыря Ход Конём',
                title: 'Три богатыря: Ход Конём',
                cost: '299 ₽'
            },

        ],
    },
    {
        id: 5,
        label: 'Сериалы',
        trackData: [
            {
                href: 'https://movix.ru/series/milliardy-327746?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/_Billions_banner_big.png',
                alt: 'Миллиарды',
            },
            {
                href: 'https://movix.ru/series/igra_prestolov-255548?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/Gameofthrones_banner_big.png',
                alt: 'Игра Престолов',
            },
            {
                href: 'https://movix.ru/movies?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/realguys.jpg',
                alt: 'Реальные пацаны',
            },
            {
                href: 'https://movix.ru/series/otel_eleon-2016-1031097?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look',
                src: '/static/images/domru-tv/look/carousel/eleonhotel.jpg',
                alt: 'Отель Элеон',
            },
        ],
        slidesData: [
            {
                href: 'https://movix.ru/series/razvod-327292?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/divorce.jpg', alt: 'Развод', title: 'Развод',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/otvetnyj_udar-264593?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/strikeback.jpg', alt: 'Ответный удар', title: 'Ответный удар',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/lubovniki-253338?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/affair.jpg', alt: 'Любовники', title: 'Любовники',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/girls.jpg', alt: 'Девочки', title: 'Девочки',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/tvin_piks-534700?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/twinpeaks.jpg', alt: 'Твин Пикс', title: 'Твин Пикс',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/stalnaa_zvezda-776229?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/tinstar.jpg', alt: 'Стальная Звезда', title: 'Стальная Звезда',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/zavuci-326054?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/viceprincipals.jpg', alt: 'Завучи', title: 'Завучи',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/series/bansi-261762?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/banshee.jpg', alt: 'Банши', title: 'Банши',
                cost: '349 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/babylonberlin.jpg', alt: 'Вавилон Берлин', title: 'Вавилон Берлин',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/series/rasskaz_sluzanki-1301114?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/thehandmaidstale.jpg', alt: 'Рассказ Служанки', title: 'Рассказ Служанки',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/movies?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/island.jpg', alt: 'Остров', title: 'Остров',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/sveta.jpg', alt: 'Света с того света', title: 'Света с того света',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/series/ivanovy_ivanovy-1000486?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/ivanovi.jpg', alt: 'Ивановы Ивановы', title: 'Ивановы Ивановы',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/phisruk.jpg', alt: 'Физрук', title: 'Физрук',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/izmeni.jpg', alt: 'Измены', title: 'Измены',
                cost: '299 ₽'
            },
            {
                href: 'https://movix.ru/series/kuhna-1121330?utm_source=domru&utm_medium=internal&utm_campaign=domrutv_look', src: '/static/images/domru-tv/look/carousel/kitchen.jpg', alt: 'Кухня', title: 'Кухня',
                cost: '299 ₽'
            },

        ],
    },
];
